import { Helmet } from "react-helmet-async";
import Layout from "../../components/Layout";
import PageTitle from "../../components/PageTitle";
import PageText from "../../components/PageText";

// ✅ Background wrapper with video
function BackgroundWrapper({ children }) {
  return (
    <div className="relative min-h-screen w-full overflow-hidden">
      {/* Video Background */}
      <video
        className="fixed inset-0 z-0 w-full h-full object-cover"
        src="/assets/bg1.mp4"
        autoPlay
        muted
        loop
        playsInline
      />

      {/* Dark overlay for readability */}
      <div className="fixed inset-0 z-0 bg-black/50" />

      {/* Content on top */}
      <div className="relative z-10">{children}</div>
    </div>
  );
}

export default function TikTok() {
  const breadcrumbJsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: "https://chaotik.org/" },
      { "@type": "ListItem", position: 2, name: "TikTok", item: "https://chaotik.org/media/tiktok" },
    ],
  };

  return (
    <BackgroundWrapper>
      <Layout>
        <Helmet>
          <title>CHAOTIK TikTok | Star Citizen Clips &amp; Highlights</title>
          <meta
            name="description"
            content="CHAOTIK Star Citizen TikToks &mdash; clips, highlights and moments from a 24/7 multi-role EU/US/AUS org."
          />
          <link rel="canonical" href="https://chaotik.org/media/tiktok" />
          <meta property="og:title" content="CHAOTIK TikTok | Star Citizen Clips" />
          <meta
            property="og:description"
            content="CHAOTIK Star Citizen TikToks — clips, highlights and moments from the org."
          />
          <meta property="og:url" content="https://chaotik.org/media/tiktok" />
          <meta name="twitter:title" content="CHAOTIK TikTok" />
          <meta name="twitter:description" content="CHAOTIK Star Citizen TikToks — clips and highlights." />
          <script type="application/ld+json">{JSON.stringify(breadcrumbJsonLd)}</script>
        </Helmet>
        <div className="flex flex-col items-center justify-center text-center mt-10 sm:mt-14">
          <PageTitle>
            <span className="text-white text-5xl sm:text-6xl md:text-7xl">CHAOTIK TikTok</span>
          </PageTitle>

          <PageText>Here's where we showcase CHAOTIK Star Citizen TikToks - clips, highlights and moments from the org.</PageText>
        </div>
      </Layout>
    </BackgroundWrapper>
  );
}
